module.exports = __webpack_public_path__ + "static/media/AU Research Roster - nano.5a023ed5.csv";